import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const SEO = ({ title, description, image, twitter }) => (
  <Helmet title={title}>
    <meta name="description" content={description} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:image" content={`https://www.bitcoin.com${image}`} />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content={`@${twitter}`} />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={`https://www.bitcoin.com${image}`} />
    <link rel="canonical" href="https://wallet.bitcoin.com/privacy-policy/" />
    <link
      rel="preconnect"
      href="https://fonts.bitcoin.com/Elza/Elza_Condensed_Black/crossmedia/Elza-CondensedBlack.woff"
      as="font"
      type="font/woff"
      crossOrigin="anonymous"
    />
    <link
      rel="preconnect"
      href="https://fonts.bitcoin.com/Satoshi_Variable/Fonts/WEB/fonts/Satoshi-Medium.woff"
      as="font"
      type="font/woff"
      crossOrigin="anonymous"
    />
    <link
      rel="preconnect"
      href="https://fonts.bitcoin.com/Chivo_Mono/ChivoMono-VariableFont_wght.ttf"
      as="font"
      type="font/ttf"
      crossOrigin="anonymous"
    />
    <link
      href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@500..900&family=Noto+Sans:ital,wdth,wght@0,75..100,500..900;1,62.5..100,500..900&display=swap"
      rel="stylesheet"
      key="google-fonts2"
    />

    <style>
      {`
            @font-face {
              font-family: 'Elza Condensed';
              src: url('https://fonts.bitcoin.com/Elza/Elza_Condensed_Black/crossmedia/Elza-CondensedBlack.woff') format('woff');
              font-style: normal;
              font-display: swap;
            }
            @font-face {
              font-family: 'Satoshi Variable Medium';
              src: url('https://fonts.bitcoin.com/Satoshi_Variable/Fonts/WEB/fonts/Satoshi-Medium.woff') format('woff');
              font-weight: normal;
              font-style: normal;
              font-display: swap;
            }
            @font-face {
              font-family: 'Chivo Mono';
              src: url('https://fonts.bitcoin.com/Chivo_Mono/ChivoMono-VariableFont_wght.ttf') format('truetype');
              font-weight: normal;
              font-style: normal;
              font-display: swap;
            }
          `}
    </style>
  </Helmet>
);

SEO.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  twitter: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
};

export default SEO;
